export default {
  lots: [],
  buy_requests: []
}
